import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default defineComponent({
  name: "listDetailTop",
  props: {
    detailTopInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    detailType: {
      type: String,
      default: "歌单"
    }
  },
  setup: function setup() {
    var router = useRouter();
    var store = useStore();
    /* 标签点击事件，跳转到歌单 */

    var tagClick = function tagClick(tag, type) {
      if (type == "歌单") {
        router.push({
          path: "/main/playlist",
          query: {
            tag: tag
          }
        });
      } else if (type == "专辑") {
        router.push("/main/artistdetail/".concat(tag));
      }
    };
    /* 点击播放全部 */


    var handlePlaylist = function handlePlaylist(id) {
      store.dispatch("player/setSongList", {
        id: id
      });
    };

    return {
      tagClick: tagClick,
      handlePlaylist: handlePlaylist
    };
  },
  components: {}
});